import React, { useState, useEffect } from "react";
import "./CreateAgentModal.scss";
import { NewUser, PictureNew, NewPortaluser } from "../../util/API/customers";
import CustomForm from "../UI/CustomForm/CustomForm";
import BaseDrawer from "../UI/BaseDrawer/BaseDrawer";
import {formatDate} from "../../util/utilfunctions/utilFunctions";
import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import CustomAlert from "../UI/CustomAlert/CustomAlert";

function CreateAgentModal({ open, handleClose }) {
  const [userData, setUserData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    birthDate: "",
    idnumber: "",
    areaCode: "",
    city: "",
    country: "",
    zip: "",
    address: "",
  });
  const [userImage, setUserImage] = useState("");
  const [userBase64, setUserBase64] = useState("");
  const [error, setError] = useState("");
  const [newUser, setNewUser] = useState("");
  const [loading, setLoading] = useState(false);
  const [roles, setRoles] = useState([]);
  const [alert, setAlert] = useState({
    showAlert: false,
    message: "",
    severity: "",
    header: "",
    userId: "",
  });

  const requiredConstants = useSelector((state) => state.constants);

  const systemRoles = async () => {
  const allRoles = requiredConstants.systemRoles || [];

  const transformedRoles = allRoles.map(role => ({
    key: role.securityrole.roleid,
    value: role.securityrole.roleid,
    label: role.securityrole.name,
  }));

  setRoles(transformedRoles);

  console.log("Filtered Roles:", transformedRoles);
};

useEffect(() => {
  systemRoles();
}, []);


  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      let img = event.target.files[0];
      let reader = new FileReader();

      reader.onload = (e) => {
        setUserImage(e.target.result);
        setUserBase64(e.target.result);
      };

      reader.readAsDataURL(img);
    }
  };

  function handleChange(evt) {
    const value = evt.target.value;
    setUserData({
      ...userData,
      [evt.target.name]: value,
    });
  }

  const handleCloseModal = () => {
    handleClose();
    setNewUser("");
    setError("");
  };
  const onSubmit = async (data, formData) => {
    setLoading(true);
    setNewUser("");
    setError("");

    // let phoneNo = data.areaCode + data.phoneno;

    // let requestData = data;

    // if (requestData?.dob) {
    //   requestData.dob = formatDate(requestData.dob);
    // }

    // if (requestData?.phoneno) {
    //   requestData.phoneno = phoneNo;
    // }

    // console.log(data)

    // try {
    //   const response = await NewUser(requestData);

    //   let callStatus = response.data.payload.callStatus;

    //   if (callStatus == 1) {
    //     let userId = response.data.payload.userid;
    //     setNewUser("User created successfully");

    //     if (userBase64) {
    //       let newPicture = await PictureNew(userId, userBase64);
    //     }
    //   } else {
    //     setError(`${response.data.payload.msg}`);
    //   }
    // } catch (error) {
    //   console.error(error);
    //   setError("An error occurred while creating the user.");
    // }
    // setLoading(false);
    const requiredFields = formData
        .filter((field) => field.validation?.required)
        .map((field) => field.name);

    const missingFields = requiredFields.filter(
        (fieldName) => !data[fieldName] || data[fieldName].toString().trim() === ""
    );

    if (missingFields.length > 0) {
      return;        
    }

    let phoneNo = data.areaCode.value + data.phoneno;

    let requestData = { ...data }; // shallow copy

    if (requestData?.dob) {
      requestData.dob = formatDate(requestData.dob);
    }

    if (requestData?.phoneno) {
      requestData.phoneno = phoneNo;
    }

    let extendedFields = {};
    formData.forEach((item) => {
      if (item.core === 0 && requestData.hasOwnProperty(item.name)) {
        extendedFields[item.name] = requestData[item.name];
        delete requestData[item.name];
      }
    });

    requestData.extendedFields = JSON.stringify(extendedFields);

    try {
      const response = await NewPortaluser(requestData);
      console.log(response);

      let callStatus = response.data.Status;

      console.log(response.data.payload.msg)

      if (callStatus === "3") {

        let userId = response?.data?.payload?.userid;

        // const response1 = await MerchantPiAdd(userId, 229, 2);
        // const response2 = await MerchantPiAdd(userId, 230, 2);
        // const response3 = await MerchantPiAdd(userId, 313, 42);

        if (callStatus === "3") {
          setNewUser("User created successfully");
          setAlert({
            showAlert: true,
            message: "Thank You! Admin User has been created successfully!",
            severity: "success",
            header: "Success"
          });
        }

        else {
          setAlert({
            showAlert: true,
            message: response?.data?.payload?.msg,
            severity: "error",
            header: "Error"
          });
        }

        // setUpdateUser(!updateUser)

        setUserData({
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          birthDate: "",
          areaCode: "",
          city: "",
          country: "",
          zip: "",
          address: "",
          role: "",
        });

        if (userBase64) {
          await PictureNew(userId, userBase64);
        }
      } else {
        setError(`${response.data.msg}`);
        setAlert({
          showAlert: true,
          message: `${response?.data?.payload?.msg}`,
          severity: "error",
          header: "Error"
        });
      }
    } catch (error) {
      console.error(error);
      setError("An error occurred while creating the user.");
    }
  };

  return (
    <BaseDrawer
      open={open}
      handleClose={handleClose}
      height="90vh"
      title={"Add New Agent"}
    >       
      <Box 
        className="centered-content"
        sx={{
          overflow: "auto", // Enable scrolling for overflowing content
          maxHeight: "90vh", // Limit the height to the viewport
        }}
      >
        <Box 
          className="customer-profile-container-modal"
          sx={{
            overflowY: 'auto', // Allow vertical scrolling
            maxHeight: 'calc(90vh - 60px)', // Adjust based on header/footer height
          }}
        >
          <Box 
            className="customer-details"
            sx={{
              display: "flex",
              justifyContent: "center", /* Center the panels horizontally */
              alignItems: "flex-start", /* Align panels at the top */
              flexDirection: "row",
              whiteSpace: "nowrap",
              overflowX: "auto",
              zIndex: "1",
            }}
          >
            <CustomForm
              formName={"newagent"}
              fieldRendererType="registration"
              useStep={true}
              onSubmit={onSubmit}
              buttonText={"Add User"}
              loadingButtonText={"Adding User..."}
              twoColumns={true}
              buttonInPanel={true}
              containerText={"Add New User"}
              isRegistration={true}
              roles={roles}
            />
          </Box>
        </Box>
      </Box>
      <CustomAlert
        severity={alert.severity}
        show={alert.showAlert}
        header={alert.header}
        message={alert.message}
        onClick={(prevDetails) => {
          setAlert({ ...prevDetails, showAlert: false });
          if (alert.severity === "success") {
            handleClose();
          }
        }}
        autoclose={alert.severity === "error" ? false : true}
      />
    </BaseDrawer>
  );
}

export default CreateAgentModal;
